export default __webpack_public_path__ + "static/media/115.850f863a.jpg";